export enum ShortSyncState {
    Connecting = 'connecting',
    Off = 'off',
    Paused = 'paused',
    On = 'on'
}

export enum ProjectSaveState {
    invalid = 'invalid',
    saving = 'saving',
    failed = 'failed',
    succeeded = 'succeeded'
}

export enum SyncState {
    Connecting = 'connecting',
    NotSubscribed = 'notSubscribed',
    NotLoggedIn = 'notLoggedIn',
    NoConnection = 'noConnection',
    Uploading = 'uploading',
    Synced = 'synced'
}

export interface ProjectsState {
    total: number;
    localOnly: number;
    synced: number;
    uploading: number;
    notSynced: number;
}
